/* Chatix storefront MOQ synchronisation. Does not modify app source settings. */
(function () {
  'use strict';
  var approved = 'Standard OEM MOQ starts at 100 units; flexible trial orders may be available for qualified new brand partners.';
  var scheduled = false;
  function synchronise() {
    scheduled = false;
    document.querySelectorAll('.spk-faq-item').forEach(function (item) {
      var question = item.querySelector('.spk-faq-que');
      var answer = item.querySelector('.spk-faq-ans');
      if (!question || !answer || !/\bMOQ\b|minimum order/i.test(question.textContent || '')) return;
      if ((answer.textContent || '').trim() === approved) return;
      var paragraph = document.createElement('p');
      paragraph.textContent = approved;
      answer.replaceChildren(paragraph);
      answer.setAttribute('data-ifw-moq-version', '100-20261027');
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (typeof window.queueMicrotask === 'function') window.queueMicrotask(synchronise);
    else Promise.resolve().then(synchronise);
  }
  function start() {
    document.documentElement.setAttribute('data-ifw-chat-moq-sync', '100-20261027');
    synchronise();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
